/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CashbackCell_cashback$ref: FragmentReference;
declare export opaque type CashbackCell_cashback$fragmentType: CashbackCell_cashback$ref;
export type CashbackCell_cashback = {|
  +id: string,
  +date: any,
  +name: string,
  +rate: ?string,
  +place: string,
  +storeId: string,
  +amount: number,
  +source: string,
  +plaidTransactionId: ?string,
  +transactionAmount: ?number,
  +state: ?string,
  +quarantinedReason: ?string,
  +availableStates: ?$ReadOnlyArray<string>,
  +$refType: CashbackCell_cashback$ref,
|};
export type CashbackCell_cashback$data = CashbackCell_cashback;
export type CashbackCell_cashback$key = {
  +$data?: CashbackCell_cashback$data,
  +$fragmentRefs: CashbackCell_cashback$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CashbackCell_cashback",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "place",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plaidTransactionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quarantinedReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableStates",
      "storageKey": null
    }
  ],
  "type": "Cashback"
};
// prettier-ignore
(node/*: any*/).hash = '1d181631a4d92a998a80c66fea047807';

module.exports = node;
